import {Product} from './Product';
import {BaseObject} from './BaseObject';

export class ProductContent extends BaseObject {
    id: number;

    productId: number;
    contentId: number;
    count: number;
    lostCount: number;

    content: Product;

    setProduct = (p: Product) => {
        this.productId = p.id;
    }

    setContent = (p: Product) => {
        this.content = p;
        this.contentId = p.id;
    }

    getContent = (): Product => {
        return this.content;
    }
}



// WEBPACK FOOTER //
// /app/src/model/Entities/ProductContent.ts